export default "__VITE_ASSET__BsASYNfD__"